// extracted by mini-css-extract-plugin
export var resourcesection = "ResourceSection-module--resourcesection--3MVzZ";
export var resourcesection__btpattern = "ResourceSection-module--resourcesection__btpattern--2S9Fh";
export var resourcesection__image = "ResourceSection-module--resourcesection__image--342Xn";
export var resourcesection__content = "ResourceSection-module--resourcesection__content--3jDa4";
export var resourcesection__contentLeft = "ResourceSection-module--resourcesection__content--left--3JNtH";
export var resourcesection__contentRight = "ResourceSection-module--resourcesection__content--right--3CUJ_";
export var fadeOutAnimation = "ResourceSection-module--fadeOutAnimation--3xrzh";
export var fadeInAnimation = "ResourceSection-module--fadeInAnimation--3Kb-J";